import { Directive, ElementRef, AfterViewInit } from '@angular/core';

// Emergency patch, to be removed later
// See: https://issues.chromium.org/issues/335553723

@Directive({
    selector: '[appRemoveAriaOwns]',
})
export class RemoveAriaOwnsDirective implements AfterViewInit {
    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        this.el.nativeElement.parentElement.removeAttribute('aria-owns');
    }
}
